<template>
  <div class="nps-scale">
    <ul class="text-center">
      <li
        class="scale-item mt-2"
        v-for="(item, index) in issue.labels"
        :key="index"
        :class="{ active: issue.value === item.id }"
        :style="issue.getActiveColor(issue.value, index)"
        @click="issue.value = item.id"
      >
        <div class="h-full relative">
          <span class="text text-small whitespace-nowrap">{{ item.num }}</span>
        </div>
      </li>
    </ul>
    <div class="text-small clearfix mt-1 text-theme-black-450">
      <span class="float-left">
        <span>{{ issue.firstLabel.num }}:</span>
        <span>{{ issue.firstLabel.text }}</span>
      </span>
      <span class="float-right">
        <span>{{ issue.lastLabel.num }}:</span>
        <span>{{ issue.lastLabel.text }}</span>
      </span>
    </div>
    <div v-if="issue.show_unknown" class="unknown-box pr-5">
      <van-radio-group :value="issue.value">
        <van-radio name="unknown" @click="issue.value = 'unknown'">
          <span class="text-theme-black-650">{{ issue.unknown_text }}</span>
          <template v-slot:icon="{ checked }">
            <icon-radio :value="checked" />
          </template>
        </van-radio>
      </van-radio-group>
    </div>
  </div>
</template>

<script>
import IconRadio from '@/components/base/IconRadio'
export default {
  name: 'NPSScale',
  components: { IconRadio },
  changeExpr: 'issue.value'
}
</script>
